import { render, staticRenderFns } from "./JobDescriptionForm.vue?vue&type=template&id=26c33b6d&scoped=true&"
import script from "./JobDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./JobDescriptionForm.vue?vue&type=style&index=0&id=26c33b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c33b6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})
